import React from 'react';

import { CheckoutLayoutBlock, PaymentBlockCardIcons } from '@order/components';
import type { SubscriptionCreditCard } from '@order/graphql';

import { SweetpassCheckoutCardPicker } from '../SweetpassCheckoutCardPicker';

export const SweetpassCheckoutCardBlock = (
  props: SweetpassCheckoutCardBlockProps,
) => {
  return (
    <CheckoutLayoutBlock>
      <PaymentBlockCardIcons />
      <SweetpassCheckoutCardPicker {...props} />
    </CheckoutLayoutBlock>
  );
};

// ─── Types ─────────────────────────────────────────────────────────────

type SweetpassCheckoutCardBlockProps = {
  readonly selectedCreditCard?: Partial<SubscriptionCreditCard>;
  readonly creditCards: ReadonlyArray<Partial<SubscriptionCreditCard>>;
  readonly handleAddCreditCard: () => void;
  readonly handleSelectCreditCard: (
    creditCard: Partial<SubscriptionCreditCard>,
  ) => void;
};
